import * as React from 'react';

function Rowing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M11.122 11.358l1.127 1.185-.656.69a1.741 1.741 0 01-.172 1.88l-.098.111-5.152 5.408c-.21.22-.49.35-.785.366a1.16 1.16 0 01-.817-.28l-.09-.086-1.129-1.184a1.285 1.285 0 01-.348-.823c-.016-.31.08-.616.266-.857l.082-.095 5.153-5.408a1.535 1.535 0 011.978-.234l.64-.673zM5.484 3.732c.622-.653 1.38-.919 1.692-.592.209.22.164.649-.076 1.105l7.419 7.785a1.535 1.535 0 011.978.235l5.153 5.408.082.095c.187.241.282.546.266.857-.015.31-.139.603-.348.823l-1.128 1.184-.091.086a1.16 1.16 0 01-.816.28 1.172 1.172 0 01-.785-.366l-5.153-5.408-.097-.111a1.746 1.746 0 01-.173-1.88L5.972 5.427c-.435.25-.844.298-1.053.08-.31-.327-.058-1.122.565-1.777zm14.033 0c.623.654.876 1.449.564 1.776-.209.219-.618.173-1.052-.08l-5.087 5.339-1.129-1.185 5.088-5.337c-.24-.456-.285-.886-.076-1.105.311-.327 1.069-.062 1.692.592z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Rowing;
